import { RootState } from "@/app/store";

export const selectFormsLoading = (state: RootState)=> state.forms.loadingForms 
export const selectFormsError = (state: RootState)=> state.forms.errorForms
export const selectForms = (state: RootState)=> state.forms.forms 
